export const OlaSortingMapping = {
  "status": "Sorting by Status",
  "changed_ascending": "Sorting by Last Changed Ascending",
  "changed_descending": "Sorting by Last Changed Descending",
  "name": "Sorting by Name Ascending",
  "name_descending": "Sorting by Name Descending",
  "isced": "Sorting by ISCED Ascending",
  "isced_descending": "Sorting by ISCED Descending",
  "receiving_country": "Sorting by Receiving Country Ascending",
  "receiving_country_descending": "Sorting by Receiving Country Descending",
};
